import { MockMethods } from 'axios-mock-server';

export const customer = {
  id: 'CustomerId',
  registered: true,
  isRegistrationRequired: true,
  isPolicyConsentRequired: false,
  surveyUrl: 'https://www.google.com/search?q=Dummy+survey+url&oq=Dummy+survey+url',
};

const mock: MockMethods = {
  post() {
    return [200, { customer }];
  },
};

export default mock;
